import { jsxs as $, jsx as s } from "react/jsx-runtime";
import { useTracking as v, onRoleButtonKeyDown as D } from "../utils.js";
import { forwardRef as K } from "react";
import { AnimatedArrow as T } from "../animated-arrow.js";
import B from "../builders-icons/dist/systems/external-link.js";
import I from "../builders-icons/dist/systems/add.js";
import t from "./card.module.css.js";
import R from "clsx/lite";
const q = K(function({
  arrow: o,
  as: h,
  children: d,
  className: u,
  icon: r,
  onClick: a,
  size: p = "md",
  tracking: g = !0,
  variant: l = "blue-blue",
  ...e
}, x) {
  const i = h || (e.href ? "a" : "div"), y = `${o}`.startsWith("external-") ? B : T, c = i !== "a" && !!a || void 0, w = !Array.isArray(d) || d.length === 1, m = l.split("-")[0], A = v(g), b = (n) => {
    (a || i === "a") && A({
      eventCategory: `card_${m}`,
      eventAction: "click"
    }), a == null || a(n);
  }, N = (n) => {
    var f;
    (f = e.onKeyDown) == null || f.call(e, n), c && n.currentTarget instanceof HTMLElement && D(n);
  };
  return !r && m === "add" && (r = /* @__PURE__ */ s(I, { className: t.addIcon })), /* @__PURE__ */ $(
    i,
    {
      ...e,
      className: R(
        u,
        t.card,
        t[`is-${w && o !== "under" && "centered"}`],
        t[`has-${r && "icon"}`],
        t[`has-arrow-${o === !0 ? "side" : o}`],
        t[p],
        t[l]
      ),
      onClick: b,
      onKeyDown: N,
      ref: x,
      role: e.role ?? (c && "button"),
      tabIndex: e.tabIndex ?? (c && 0),
      children: [
        !r || /* @__PURE__ */ s("span", { className: t.icon, children: r }),
        !o || /* @__PURE__ */ s(y, { className: t.arrow }),
        m === "add" && /* @__PURE__ */ s("svg", { className: t.addDashes, vectorEffect: "non-scaling-stroke", children: /* @__PURE__ */ s("rect", { x: "0", rx: "8", ry: "8", width: "100%", height: "100%" }) }),
        d
      ]
    }
  );
});
export {
  q as Card
};
//# sourceMappingURL=card.js.map
